import React, { useState, useEffect, useMemo, Fragment, useRef } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Button,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from "reactstrap";
import { useForm } from "react-hook-form";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import { H3, Btn, Breadcrumbs, H4 } from "../../../AbstractElements";
import { Link, useNavigate } from "react-router-dom";
import {
  addSetupCost,
  getclientpackage,
  getUserList,
  postShowTemp,
  postShowTrail,
} from "../../../CommonURL";
import {
  getDataWithToken,
  postDataWithToken,
  postMasterToken,
} from "../../../Utils/restUtils";
import { Add, Status } from "../../../Constant";
import { TempDataColumns } from "../../../Data/MockTable/TempData";
import SearchList from "../../../CommonElements/Search";
import Transparentspinner from "../../Common/loader/Transparentspinner";
import { Typeahead } from "react-bootstrap-typeahead";
import { toast } from "react-toastify";
import IndustryFilter from "../../Common/Filters/IndustryFilter";
import CompanyFilter from "../../Common/Filters/CompanyFilter";
import UserFilter from "../../Common/Filters/UserFilter";
import { statusOptions } from "../../../Constant/DropdownValue";

const UsersTable = () => {
  const style2 = { width: 60, fontSize: 13, padding: 3, marginRight: "10px" };
  const [tempList, setTempList] = useState([]);
  const [tempDataValue, setTempDataValue] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [searchResetKey, setSearchResetKey] = useState(0);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [packageOptions, setPackageOptions] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isIndustry, setIsIndustry] = useState("");
  const [appliedFilters, setAppliedFilters] = useState({});
  const [isCompany, setIsCompany] = useState("");
  const [isUser, setIsUser] = useState("");
  const [dateRange, setDateRange] = useState([]);
  const isStatus = useRef(null);
  const [startDate, endDate] = dateRange;
  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };
  const navigate = useNavigate();
  useEffect(() => {
    fetchUsers(1);
  }, []);
  const UsersDataColumns = (redirectTopackage) => [
    {
      name: <H4>Sl No</H4>,
      cell: (row, index) => (currentPage - 1) * perPage + index + 1,
      sortable: true,
      width: "70px",
      center:true
    },
    // {
    //   name: <i className="fa fa-gears" style={{ fontSize: "15px" }}></i>,
    //   selector: (row) => row.action,
    //   cell: (row) => <ActionCell row={row} />,
    //   center: true,
    //   width: "55px",
    // },
    {
      name: <H4>Name</H4>,
      selector: (row) => (
        <Link
          to={`${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${row.id}`}
        >
          {row.user_name}
        </Link>
      ),
      sortable: true,
      width: "170px",
      wrap: true,
    },

    {
      name: <H4>Industry</H4>,
      selector: (row) => row.industry_name,
      sortable: true,
      width: "150px",
      wrap: true,
    },

    {
      name: <H4>Phone No</H4>,
      selector: (row) => "+" + row.country_code + row.mobile,
      sortable: true,
      width: "170px",
      wrap: true,
    },
    {
      name: <H4>Email</H4>,
      selector: (row) => row.email,
      sortable: true,
      width: "230px",
      wrap: true,
    },
    {
      name: <H4>Status</H4>,
      selector: (row) => row.Status,
      cell: (row) => (
        <span className={`badge badge-${row.status}`}>{row.status}</span>
      ),
      sortable: true,
      width: "150px",
      wrap: true,
    },
    {
      name: <H4>State</H4>,
      selector: (row) => row.state,
      sortable: true,
      width: "150px",
      wrap: true,
    },

    {
      name: <H4>Country</H4>,
      selector: (row) => row.country,
      sortable: true,
      width: "100px",
      wrap: true,
    },
  ];
  const handleFilter = () => {
    const filters = {
      industry_id: isIndustry?.value || "",
      company_id: isCompany?.value || "",
      search: searchKeyword,
      start_date: startDate ? startDate.toISOString().split("T")[0] : "",
      end_date: endDate ? endDate.toISOString().split("T")[0] : "",
      user_id: isUser?.value || "",
      status: isStatus.current?.value || "",
    };

    setAppliedFilters(filters);
    setCurrentPage(1);
    fetchUsers(1, perPage, filters);
  };

  const ResetFileter = () => {
    setIsCompany(null);
    setIsIndustry(null);
    setDateRange([null, null]);
    setSearchResetKey((prev) => prev + 1);
    setAppliedFilters({});
    setCurrentPage(1);
    fetchUsers(1, perPage, {});
  };
  const updateSearchKeyword = (keyword) => {
    setSearchKeyword(keyword);
  };
  const redirectTopackage = (row) => {
    setSelectedUser({
      user_id: row.user_id,
      company_id: row.company_id,
      industry_id: row.industry_type_id,
    });

    setShowPlanModal(true);
  };

  const fetchUsers = async (page, size = perPage, filters = {}) => {
    setLoading(true);

    const {
      industry_id = "",
      search = "",
      user_id = "",
      status = "",
    } = filters;

    const response = await getDataWithToken(
      `${getUserList}?page=${page}&page_length=${size}&search=${search}&industry_type_id=${industry_id}&user_id=${user_id}&status=${status}`,
    );
    setTempDataValue(response?.data?.data);
    setTotalRows(response?.data?.total);
    setLoading(false);
  };

  const handlePageChange = (page) => {
    fetchUsers(page, perPage, appliedFilters);
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    fetchUsers(page, newPerPage, appliedFilters);
  };

  const handleCancel = () => {
    setShowPlanModal(false);
  };
  const ActionCell = ({ row }) => {
    const [dropdownOpen, setDropdownOpen] = React.useState(false);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    return (
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
        <DropdownToggle
          color="#00000"
          style={{ fontSize: "14px", zIndex: 1000 }}
        >
          <i className="fa fa-ellipsis-v"></i>
        </DropdownToggle>
        <DropdownMenu container="body">
          <DropdownItem
            style={toggleStyle}
            onClick={() => redirectTopackage(row)}
          >
            Renew
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  };

  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs mainTitle="Users" parent="Subscriptions" title="Users" />
      <Card>
        <CardHeader>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <H3>Users List</H3>
          </div>
          <form
            className="px-4 pb-2"
            onSubmit={(e) => {
              e.preventDefault();
              handleFilter();
            }}
          >
            <Row className="g-3 align-items-center">
              <Col sm="12" md="5" lg="3" className="pt-3">
                <SearchList
                  key={searchResetKey}
                  className="form-control"
                  updateSearchKeyword={updateSearchKeyword}
                  onEnter={handleFilter}
                />
              </Col>
              {/* <Col sm="12" md="6" lg="3">
                <DatePicker
                  className="form-control digits w-100"
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                  isClearable={!!(startDate || endDate)}
                  monthsShown={2}
                  popperPlacement="bottom"
                  calendarClassName="parallel-calendar"
                  placeholderText="Select Date Range"
                  dateFormat="dd-MM-yyyy"
                />
              </Col> */}
              <Col sm="12" md="6" lg="3">
                <IndustryFilter
                  IsIndustry={isIndustry}
                  setIsIndustry={setIsIndustry}
                />
              </Col>
              <Col sm="12" md="6" lg="3">
                <UserFilter IsUser={isUser} setIsUser={setIsUser} />
              </Col>
              <Col sm="12" md="5" lg="2" className="form-element">
                <select className="form-select" ref={isStatus}>
                  <option value="">{Status}</option>
                  {statusOptions.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </Col>

              <Col sm="12" md="6" lg="3">
                <div style={{ display: "flex", gap: "10px" }}>
                  <button className="btn btn-primary" onClick={handleFilter}>
                    Filter
                  </button>

                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={ResetFileter}
                  >
                    Reset
                  </button>
                </div>
              </Col>
            </Row>
          </form>
        </CardHeader>
        <CardBody>
          <div className="order-history table-responsive">
            <DataTable
              columns={UsersDataColumns(redirectTopackage)}
              data={tempDataValue}
              pagination
              paginationServer
              defaultSortAsc
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default UsersTable;
